import axios from "axios";

import Utils from "../../../components.utils.js"
import Constants from "../../../components.constants.js";
import allRoute from "../../../routes/index.js"

export default {
  async loadUserInfoFromCookies(context) {
    let session_id = Utils.getCookieValue("session_id");
    let sessionIDLocalStorage = Utils.getLocalStorageValue("sessionId");
    if(sessionIDLocalStorage != null  && String(window.location.href).indexOf('fusion-browse/blaze') > -1){
      try{
        let userInfo = JSON.parse(Utils.getLocalStorageValue("userInfo"));
        if(userInfo && Object.keys(userInfo).length){
          context.commit("setCurrentUserinfo", userInfo);
          return;
        }
      }catch(e){console.log(e)}
    }
    if (session_id == null){
      Utils.unsetLoginCookie()
      context.commit("unsetUserinfo")
      Utils.setLocalStorageValue("userInfo",JSON.stringify({}))
    }else{
      let userInfo = JSON.parse(Utils.getLocalStorageValue("userInfo"));
      context.commit("setCurrentUserinfo", userInfo)
    }
  },

  async logInToServer(context, payload) {
    //payload : {username:"abc", password:"cba"}
    try {
      let resp = await axios.post(Constants.loginUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        context.commit("setCurrentUserinfo", resp.data.user_info)
        Utils.setLoginCookie(resp.data.user_info._id)
        Utils.setLocalStorageValue("userInfo", JSON.stringify(resp.data.user_info))
        if(resp && resp.data && resp.data.user_info && resp.data.user_info._id)
           Utils.setLocalStorageValue("fusion:u_id", JSON.stringify(resp.data.user_info._id));
        if(resp && resp.request.getResponseHeader('session_id'))
             localStorage.setItem('sessionId',resp.request.getResponseHeader('session_id'));
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[logInToServer][Store][Error occured while logging in user--->${error}]`
      );
      if (error.response) {
        if (Constants.rejectedStatusCodes.includes( error.response.status)){
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {};
    }
  },

  async logOutFromServer(context) {
    try {
      let resp = await axios.delete(Constants.logoutUrl);
      if (Constants.acceptedStatusCodes.includes(resp.status)) { 
        //Some Code
      } else if (resp.status == 401) {
        //check_authorized conditions
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[logOutFromServer][Store][Error occured while logging out user--->${error}]`
      );
    }
    context.commit("unsetUserinfo")
    Utils.unsetLoginCookie();
    Utils.setLocalStorageValue("userInfo",JSON.stringify({}))
    try{ // close websocket connection
      context.commit("websocket/closeWebsocketConnection", {}, { root: true })
    }catch(e){console.log(e)}
    try{
        let lastRoute = context.rootGetters['locations/getLocationinfoToLoad'];
        if ( lastRoute.name=='terms' || lastRoute.name=='policy') {
            allRoute.push({name:lastRoute.name})
            return;
        }
    }catch(e){console.log(e)}
    const determinePreviewURL = function(){
      let url = window.location.href;
      let pattern = /((\/assets)\/([a-zA-Z0-9]+)\/(view))/;
      if(pattern.test(String(url))){
        // if(!Utils.getCookieValue("userId")){
            let resultList = pattern.exec(url);
            return {redirectUrl:`/assets/${resultList[3]}/view`}
        // }
      }else if(String(url).indexOf('/login') == -1){
        return {continue: location.pathname};
      }
      return "";
    }
    let p = determinePreviewURL();
    let isLoginUrl = String(window.location.href).indexOf('/login') > -1;
    try{
      if(!isLoginUrl)
         this.$router.push({name:"login", query:p})
    }catch(e){
      console.log(e);
      if(!isLoginUrl)
         allRoute.push({name:"login", query:p});
    }
    return {};
  },

  async getUsersAutoComplitionFromServer(context, payload ={}){
    try {
      let resp = await axios.get(Constants.usersAutoComplitionUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getUsersAutoComplitionFromServer][Store][Error occured while getting userslist--->${error}]`
      );
      if (error.response) {
        error.response.data.statusCode = error.response.status
        return error.response.data
      }
      return {}
    }
  },

  async getAllUsersFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.usersUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAllUsersFromServer][Store][Error occured while getting userslist--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async addNewUser(context, payload = {}) {
    //payload : FUSION Users JSON schema

    try {
      let resp = await axios.post(Constants.usersUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[addNewUser][Store][User add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[addNewUser][Store][Error occured while adding user--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async updateExistingUser(context, payload = {}) {
    //payload : {params:{userId: "23412123"}, data:DAM Users JSON schema}

    try {
      if(context.state.loggedInUserId == payload.params.user_id){
        let payloadParams = payload["params"];
        payloadParams["effective_access_control"] = true;
        payload["params"] = payloadParams;
      }
      let resp = await axios.put(`${Constants.usersUrl}/${payload.params.user_id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[updateExistingUser][Store][User update resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        if (payload.params.user_id == context.state.loggedInUserInfo._id){
          context.dispatch("updateLoggedInUserInfo",{})
        } 
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateExistingUser][Store][Error occured while updating user--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async userGetVerificationCode(context, payload = {}) {
    try {
        let resp = await axios.put(`${Constants.userGetVerificationCodeURL}`, payload.params);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[userGetVerificationCode][Store][Mail config update resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[userGetVerificationCode][Store][Error occured while updating mail config--->${error}]`
        );
        if (error.response) {
            error.response.data.statusCode = error.response.status
            return error.response.data
        }
        return {}
    }
  },

  async verifyLoggedInUserEmailId(context, payload = {}) {
    try {
        let resp = await axios.put(`${Constants.userProfileEmailVerifyURL}`, payload.params);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[verifyLoggedInUserEmailId][Store][Mail config update resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[verifyLoggedInUserEmailId][Store][Error occured while updating mail config--->${error}]`
        );
        if (error.response) {
            error.response.data.statusCode = error.response.status
            return error.response.data
        }
        return {}
    }
  },

  async getLoggedInUSerEmailVerifyStatus(context, payload={}){
    try {
      let resp = await axios.get(`${Constants.userProfileVerifyEmailStatusURL}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status;
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getLoggedInUSerEmailVerifyStatus][Store][Error occured while loggedin user info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }    
  },

  async updateLoggedInUserPreferences(context, payload = {}) {
    //payload : {params:{userId: "23412123"}, data:DAM Users JSON schema}

    try {
      if(context.state.loggedInUserId == payload.params.user_id){
        let payloadParams = payload["params"];
        payloadParams["effective_access_control"] = true;
        payload["params"] = payloadParams;
      }
      let resp = await axios.put(`${Constants.loggedInUserUrl}/${payload.params.user_id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[updateLoggedInUserPreferences][Store][User update resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        if (payload.params.user_id == context.state.loggedInUserInfo._id){
          context.dispatch("updateLoggedInUserPreferences",{})
        } 
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateLoggedInUserPreferences][Store][Error occured while updating user--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  

  async deleteExistingUser(context, payload = {}) {
    //payload : {params:{userId: "23412123"}, data:DAM Users JSON schema}


    try {
      let resp = await axios.delete(`${Constants.usersUrl}/${payload.userId}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[deleteExistingUser][Store][User Delete resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[deleteExistingUser][Store][Error occured while updating user--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },
  async getUserInfoFromServer(context, payload = {}) {
    //payload : {params:{userId:"3422344231"}}

    try {
      let userUrl = Constants.usersUrl;
      if('userId' in payload.params){
        userUrl += '/' + payload.params.userId;
        delete payload.params.userId
      }

      let resp = await axios.get(userUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        if (payload.params.userId == context.state.loggedInUserInfo._id){
          Utils.setLocalStorageValue("userInfo", JSON.stringify(resp.data.user))
          context.commit("setCurrentUserinfo", resp.data.user)
        } 
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getUserInfoFromServer][Store][Error occured while getting userinfo --->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },



  async updateLoggedInUserInfo(context){
    try {
      let payload = {}
      payload["params"] = {effective_access_control:true}
      let resp = await axios.get(`${Constants.usersUrl}/${context.state.loggedInUserId}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        let userData = resp.data.user;
        let oldUserInfo = context.state.loggedInUserInfo || {};
        let oldEmail = oldUserInfo.email;
        let newEmail = userData.email;
        let isEmailChanged = oldEmail && newEmail && oldEmail !== newEmail;
        if (isEmailChanged) {
          userData.email_status = userData.email_status || "unverified";
        }else  
        if(userData && userData.email_status && userData.email_status != 'verified'){
          let emailStatusResp = await context.dispatch("getLoggedInUSerEmailVerifyStatus",{})
          if(emailStatusResp && emailStatusResp.status){
            userData["email_status"] = emailStatusResp.status;
          }
        }

        resp.data.user = userData;      
        context.commit("setCurrentUserinfo", resp.data.user)
        context.dispatch("privileges/updateAllUserActionstoInMem", {}, {root:true})
        Utils.setLocalStorageValue("userInfo", JSON.stringify(resp.data.user))
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getLoggedInUserInfo][Store][Error occured while loggedin user info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }    
  },

  async checkUserLoginStatus(context, payload = {}) {
    //payload : {params:{query: {user_id:"3422344231"}}}

    try {
      let resp = await axios.get(`${Constants.loginUrl}/status`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[checkUserLoginStatus][Store][Error occured while checking user login info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async forceLogoutUser(context, payload = {}) {
    //payload : {params:{query: {user_id:"3422344231"}}}
    if (payload.params.query.user_id === context.state.loggedInUserInfo._id) {
      return context.dispatch("logOutFromServer", payload)
    }

    try {
      let resp = await axios.delete(Constants.logoutUrl , payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[forceLogoutUser][Store][Error occured while logging out user info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getAllUserNotificationsFromServer(context, payload = {}) {
    try {
        let resp = await axios.get(Constants.userNotificationUrl, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[getAllUserNotificationsFromServer][Store][Error occured while getting user notifications List--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("logOutFromServer")
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },

  async updateNotificationAsRead(context, payload = {}) {
    try {
        let resp = await axios.put(Constants.userNotificationUrl, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[updateNotificationAsRead][Store][Error occured while updating user notification--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("logOutFromServer")
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },

  async getSessionUserNotifSettings(context, payload = {}) {
    try {
        let resp = await axios.get(Constants.userNotificationSettingUrl, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[getSessionUserNotifSettings][Store][Error occured while getting user notification settings List--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("logOutFromServer")
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },

  async updateNotificationSettings(context, payload = {}) {
    try {
        let resp = await axios.put(Constants.userNotificationSettingUrl, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[updateNotificationSettings][Store][Error occured while updating user notification settings--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("logOutFromServer")
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },

  async updateUserPreferences(context, payload = {}) {
    try {
        let resp = await axios.put(`${Constants.userPreferencesURL + '/' +payload._id}`, payload.params);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[updateUserPreferences][Store][Error occured while updating user preferences--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("logOutFromServer")
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  }
};
